import React from 'react';
import { WebUiButton } from 'src/modules/web-ui/components/button';

import { postWebUiApi } from '../../../api';

type Props = {
  readonly: boolean;
  usb: boolean;
  setUsb: React.Dispatch<React.SetStateAction<boolean>>;
  runSet: (fn: () => Promise<void>, ok: string) => void;
};

export default function CSystemUsbPanel({
  readonly,
  usb,
  setUsb,
  runSet,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      <h4 className="font-bold">System Settings</h4>
      <table className="webui-table w-full">
        <thead>
          <tr className="webui-table-row-head">
            <th>Name</th>
            <th>Setting</th>
          </tr>
        </thead>
        <tbody>
          <tr className="webui-table-row-content">
            <td>USB API access</td>
            <td>
              <input
                type="checkbox"
                disabled={readonly}
                checked={usb}
                onChange={(e) => setUsb(e.target.checked)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <WebUiButton
          disabled={readonly}
          onClick={() =>
            runSet(
              () =>
                postWebUiApi({
                  service: 'usbapi',
                  access: 'set',
                  command: 'state',
                  parameters: { state: usb },
                }),
              'USB API updated.',
            )
          }
        >
          Set System Settings
        </WebUiButton>
      </div>
    </div>
  );
}
